import { APIProvider } from "@vis.gl/react-google-maps";
import { ReactNode } from "react";

type GoogleMapsProviderProps = {
  children: ReactNode;
};

export function GoogleMapsProvider(props: GoogleMapsProviderProps) {
  return <APIProvider apiKey={process.env["REACT_APP_GOOGLE"] || ""}>{props.children}</APIProvider>;
}
